module.exports = __webpack_public_path__ + "media/call-classic.3ee923fd.wav";